import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-realizado',
  templateUrl: './realizado.component.html',
  styleUrls: ['./realizado.component.scss']
})
export class RealizadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
